<template>
  <v-container class="layout-container">
    <Settings />
  </v-container>
</template>

<script>
import Settings from '@/modules/settings'
export default {
  components: {
    Settings,
  },
}
</script>
